import { hideVisually, rem, rgba } from 'polished';
import styled from 'styled-components';

import { IUserType } from '../../';
import {
  IStyledContentIndexProps,
  IStyledListItemLinkProps,
  IStyledWrapperProps,
} from './ContentIndex.types';

export const StyledLink = styled.a<IUserType>`
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: flex;
    justify-content: center;
    color: ${({ theme, user }) => user && theme.colors[user].main};
    font-weight: 700;
    font-size: ${rem('14px')};
    text-decoration: none;
    text-transform: uppercase;
  }
`;

export const StyledList = styled.ul<IStyledContentIndexProps>`
  list-style: none;
  width: 100%;
  margin: 0;
  padding: 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    padding: ${rem('24px')} ${rem('16px')};
  }
`;

export const StyledListItem = styled.li`
  position: relative;
  color: ${({ theme }) => theme.colors.cross.grayson};
  text-align: left;
  list-style: none;

  &:not(:last-child) {
    margin-bottom: ${rem('24px')};
  }
`;

export const StyledListItemLink = styled.a<IStyledListItemLinkProps>`
  display: flex;
  color: inherit;
  text-decoration: none;

  ${({ active, theme, user }) =>
    user &&
    active &&
    `
    color: ${theme.colors[user].main};
  `};

  &:hover {
    color: ${({ active, theme, user }) =>
      user && !active && theme.colors.cross.black};
  }
`;

export const StyledPanel = styled.div`
  padding-bottom: ${rem('24px')};
  list-style: none;
  width: 100%;
  margin: 0;
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};

  &[aria-hidden='true'] {
    ${hideVisually()};
  }

  &[aria-hidden='false'] {
    position: absolute;
    top: ${rem('65px')};
    border-bottom-right-radius: ${rem('16px')};
    border-bottom-left-radius: ${rem('16px')};
    box-shadow: 0 ${rem('8px')} ${rem('8px')} ${rem('-8px')}
      ${({ theme }) => rgba(theme.colors.cross.silverFox, 0.5)};
  }
`;

export const StyledArrow = styled.span`
  svg {
    width: ${rem('11px')};
    height: auto;
  }
`;

export const StyledButton = styled.button<IUserType>`
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: ${rem('24px')} 0;
  color: ${({ theme, user }) => user && theme.colors[user].main};
  font-size: ${rem('16px')};
  font-weight: 700;
  background-color: transparent;
  border: none;
  appearance: none;
  cursor: pointer;

  &[aria-expanded='true'] {
    ${StyledArrow} svg {
      transform: rotate(180deg);
    }
  }
`;

export const StyledStaticWrapper = styled.div`
  margin-bottom: ${rem('40px')};

  ${StyledList} {
    padding: ${rem('16px')};
    background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
    border-radius: ${rem('16px')};
  }
`;

export const StyledWrapper = styled.div<IStyledWrapperProps>`
  position: sticky;
  top: ${rem('71px')};
  z-index: 2;
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
  margin-bottom: ${rem('24px')};

  ${({ active, theme }) =>
    !active &&
    `
    @media screen and (max-width: ${theme.breakpoints.l}) {
      border-bottom-right-radius: ${rem('16px')};
      border-bottom-left-radius: ${rem('16px')};
      box-shadow: 0 ${rem('8px')} ${rem('8px')} ${rem('-8px')} ${rgba(
      theme.colors.cross.silverFox,
      0.5,
    )};
    }
  `}

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    margin-right: ${rem('24px')};
    height: calc(100vw - ${rem('96px')});
    padding-bottom: ${rem('32px')};
    width: auto;
    border-radius: ${rem('16px')};
  }
`;

export const StyledRefDiv = styled.div`
  height: ${rem('1px')};
`;
